import Insights from "./Insights";

function AudienceInsights() {
  return <Insights type={"TAI"} />;
}

export default AudienceInsights;
